import services from './../../services/service'; // Service Class
import MainHeader from './../Main-Header/index.vue'; // Dashboard Header
import Sidebar from './../Sidebar/index.vue'; // Dashboard Sidebar
import MainFooter from './../Main-Footer/index.vue'; // Dashboard Footer
let service = new services();

export default {
    name: 'Users',
    data () {
        return {
            admin:{},
            users: {},
            user: {},
            user_analytics:{},
            viewFlag: false,
            img_url: service.imageURL,
            deleteRequest: false,
            editRequest: false,
            wallet_transactions:{},
            user_current_wallet_balance: 0,
            user_wallet_transactions:{},
            user_wallet_transaction:{},
            topup_user_wallet: false,
            wallet_topup_amt:0,
            wallet_topup_descr:"Top-up By Admin",
            wallet_payment_message:"",
            user_referrals:{},
            user_referral_code:"-",
            user_referral_total:0,
            disable_btn:false,
        }
    },
    components: {
        'component-header': MainHeader,
        'component-sidebar': Sidebar,
        'component-footer': MainFooter
    },
    methods: {
        //settings
        setPanel(attr,attr2) {
            this.panelFlag = true;
            if(attr == "view"){
                this.viewFlag = true;
                this.user = attr2;
                this.getUserAnalytics();
                this.getUserWalletTransactions();
                this.getUserReferralTransactions();
            }
            if(attr == "topup"){
                this.topup_user_wallet = true;
                
            }

        },
        reset_view(){
            this.viewFlag = false;
            this.user = {};
        },
        reset(){
            this.topup_user_wallet = false;
        },
        togglePanel(id){
            var x = document.getElementById(id);
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        requests(req){
            if(req == "delete"){ this.deleteRequest = true;}
            if(req == "edit"){ this.editRequest = true;}
            if(req == "reset"){ this.editRequest = false; this.deleteRequest = false;}
        },
        isActive(index){
            if(index == 1){
                return "active";
            }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.admin.admin_id = element.admin_id;
                        }, this);
                        }else {
                            this.$router.push('/');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('/');
                    }
                })
            }else {
                this.$router.push('/');
            }
            
        },

        //quotes and contracts
        
        //get all saved listings
        getUsers() {
            service.getUsers(this).then(data => {
               if(data.body.status == 200) {
                    this.users = data.body.data;
                 }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },


        //get user analytics
        getUserAnalytics() {
            service.getUserAnalytics(this, this.user.user_id).then(data => {
               if(data.body.status == 200) {
                    this.user_analytics = data.body.data;
                  }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        //edit user
        editUser() {
            service.adminEditUsers(this, this.user.user_id, this.user).then(data => {
               if(data.body.status == 200) {
                    toastr.success('Updated', 'Warning!');
                    this.editRequest = false;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        //delete user
        deleteUser() {
            service.deleteUsers(this, this.user.user_id).then(data => {
               if(data.body.status == 200) {
                    toastr.success('Removed', 'Warning!');
                    location.reload(true);
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },


        onFileChange(e, user) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {
                let formData = new FormData();
                formData.append('photo', files[0]); 
                formData.append('data_id', user);
                formData.append('data_type', "users");   
                service.uploadDataPhoto(this, formData).then(data => {
                    if(data.body.status == 200){
                       // console.log("bhh")
                        this.user.user_image = data.body.data;
                    }
                  }).catch((err) => {
                    if(err) {
                       // log it
                    }
                })
            }   
            
        },
        //get all saved listing
    //     getMoney(id) {
    //        service.getMoney(this, id).then(data => {
    //            if(data.body.status == 200) {
    //                 this.money = data.body.data;
    //             }
    //         }).catch((err) => {
    //             if(err) {
    //                 toastr.error('Sorry, could not process information', 'Warning!');
    //             }
    //         })
    //     },

    // setPayment(money) {
    //     if(this.user.user_id != null){
    //         //CALL PAYMENT GATEWAY
    //         this.processPayment(money);
    //     }
    // },
    //     //connect to a payment gateway
    // processPayment(data) {
    //         let obj = this;
    //         this.amount_paid = data.payment_amount;
    //         var handler = PaystackPop.setup({
    //         key: 'pk_test_b915923b884bfffb5b84b55d008cd407328a1173',
    //         Name: data.payment_user,
    //         //email: data.payment_user_email,
    //         email: "keneinfostream@gmail.com",
    //         amount: (data.payment_amount * 100), //in kobo
    //         ref: data.payment_ref,
    //         metadata: {
    //             custom_fields: [
    //                 {
    //                     display_name: "Customer Name",
    //                     variable_name: "customer_name",
    //                     value: data.payment_user
    //                 },
    //                 {
    //                     display_name: "Service",
    //                     variable_name: "service_type",
    //                     value: data.payment_service
    //                 }
                    
    //             ]
    //         },
            
    //         callback: function(response){
    //             obj.updatePayment(response.trxref); 
                
    //         },
    //         onClose: function(){
    //             alert('window closed');
    //         }
    //         }); 
    //         handler.openIframe();
    //     },


    //     // update payments
    //     updatePayment(payment_ref) {
    //          var credentials = {
    //             amount_paid: this.amount_paid,
    //             payment_ref: payment_ref
    //         }
    //         let navi = this.$router;
            
    //         if(payment_ref != "") {
    //             service.updateMoniesPaid(this, payment_ref, credentials).then(data => {
    //                 if(data.body.status == 200) {
    //                     toastr.success("Payment Processed!", "Success!");
    //                     this.$router.go('/mymoney');
    //                 }else {
    //                     toastr.error('Sorry, could not update payment', 'Warning!');
    //                 }
    //             }).catch((err) => {
    //                 if(err) {
    //                     toastr.error('Sorry, could not process information', 'Warning!');
    //                 }
    //             })
    //         }else {
    //            toastr.error('Something went wrong', 'Warning!');
    //         }
            
    //     },

    //wallet
    setWalletTransaction(txn){
        this.user_wallet_transaction = txn;
    },
    getUserWalletTransactions() {
        service.getUserWalletTransactions(this,this.user.user_ref_no).then(data => {
             if(data.body.status == 200) {
                 this.user_current_wallet_balance = data.body.data_current_wallet_balance;
             }
             this.user_wallet_transactions = data.body.data;
         }).catch((err) => {
             if(err) {
                 toastr.error('Sorry, could not process information', 'Warning!');
             }
         })
    },
    getWalletTransactions() {
        service.getWalletTransactions(this).then(data => {
            //  if(data.body.status == 200) {
            //      this.user_current_wallet_balance = data.body.data_current_wallet_balance;
            //  }
             this.wallet_transactions = data.body.data;
         }).catch((err) => {
             if(err) {
                 toastr.error('Sorry, could not process information', 'Warning!');
             }
         })
    },

    formatCurrency(currency){
        currency =  Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN'}).format(currency);
        return currency.replace("NGN", ""); //strip off NGN
    },

    topupUserWallet(){
        this.disable_btn =  true;
        let txn_payload={
            "pay": this.user.user_ref_no,
            "txn_amount": this.wallet_topup_amt,
            "processing_fee": 0,
            "topup_by_admin": 1,
            "topup_by_admin_descr": this.wallet_topup_descr,
            "total_amount": (this.wallet_topup_amt + 0)
        };
        //post payment
        service.postWalletTopup(this,txn_payload).then(response => {
            this.getUserWalletTransactions();
            //success message
            this.wallet_payment_message = "You have successfully topped up  CNwallet with ₦" + this.wallet_topup_amt;
            //this.loading = true;
            this.disable_btn = false;
            this.topup_user_wallet = false;
           
        }).catch((err) => {
            //console.log(err)
        })
    },

    //wallet

    //referrals
    getUserReferralTransactions() {
        service.getUserReferralTransactions(this,this.user.user_ref_no).then(data => {
             this.user_referrals = data.body.data;
             this.user_referral_code = data.body.data_referral_code;
             this.user_referral_total = data.body.data_referral_total;
        }).catch((err) => {
             if(err) {
                 toastr.error('Sorry, could not process information', 'Warning!');
             }
         })
    },
    //../.referrals
        
    },
    created: function(){
        this.preset();
        this.getUsers();
        this.getWalletTransactions();
    }
}


// WEBPACK FOOTER //
// ./src/components/Users/script.js